import { EContentPanelRoute, MeetingTypeEnum, type Collection, type Meeting, type UserService } from 'lingo2-models';

export class ContentRouter {
  public static meetingRoute(meeting: Pick<Meeting, 'subject' | 'type' | 'title' | 'slug'>): string[] {
    if (meeting) {
      const subjectCode = meeting.subject ? meeting.subject.code : null;
      const typeCode = this.meetingTypeUrlMap[meeting.type] || this.meetingTypeUrlMap[MeetingTypeEnum.group];
      const title = (meeting.title || '')
        .replace(/[\\\/:;{}\[\]()_,-.!?'"`+#&=]/g, '')
        .trim()
        .replace(/\s+/g, '-');
      return [
        '/' + EContentPanelRoute.classes,
        subjectCode || '-',
        typeCode,
        (title.length ? title + '-' : '') + meeting.slug,
      ];
    } else {
      return null;
    }
  }

  public static meetingJoinRoute(item: Meeting): string[] {
    if (item) return this.meetingJoinRouteBySlug(item.slug);
    else return null;
  }

  public static meetingJoinRouteBySlug(slug: string): string[] {
    return ['/' + EContentPanelRoute.classes, 'join', slug];
  }

  public static meetingTypeUrlMap: { [key: number]: string } = {
    [MeetingTypeEnum.single]: 'individual-lessons',
    [MeetingTypeEnum.group]: 'group-lessons',
    [MeetingTypeEnum.webinar]: 'webinars',
    [MeetingTypeEnum.stream]: 'streams',
  };

  /** Полная ссылка на страницу индивидуального занятия */
  public static userServiceRouteUniversal(item: Pick<UserService, 'subject' | 'category' | 'title' | 'slug'>): string {
    if (item) {
      const subjectCode = item.subject?.code || '-';
      const typeCode = item.category?.code || '-';
      const title = (item.title || '')
        .replace(/[\\\/:;{}\[\]()_,-.!?'"`+#&=]/g, '')
        .trim()
        .replace(/\s+/g, '-');
      return [
        '/' + subjectCode,
        EContentPanelRoute.classes,
        typeCode,
        (title.length ? title + '-' : '') + item.slug,
      ].join('/');
    } else {
      return null;
    }
  }

  public static collectionRouteUniversal(item: Pick<Collection, 'subject' | 'title' | 'slug'>): string {
    if (item && item.slug) {
      const subjectCode = item.subject?.code || '-';
      const typeCode = 'collection';
      const title = (item.title || '')
        .replace(/[\\\/:;{}\[\]()_,-.!?'"`+#&=]/g, '')
        .trim()
        .replace(/\s+/g, '-');
      return [
        '/' + subjectCode,
        EContentPanelRoute.collections,
        typeCode,
        (title.length ? title + '-' : '') + item.slug,
      ].join('/');
    }
    return null;
  }
}
